import React, { useState } from "react";
import clientContext from "./clientContext";
import API_BASE from "../../apiConfig";

const ClientState = (props) => {
    const host = API_BASE; // backend API endpoint

    const [clients, setClients] = useState([]);

    // Get all clients
    const fetchAllClients = async () => {
        try {
            const response = await fetch(`${host}/api/clients/fetchallclients`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token") // if using JWT
                }
            });
            const data = await response.json();
            setClients(data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    // Add a client
    const addClient = async (clientName, clientGSTIN, clientAddress, clientEmail, clientPhone) => {
        try {
            const response = await fetch(`${host}/api/clients/addclient`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                },
                body: JSON.stringify({ clientName, clientGSTIN, clientAddress, clientEmail, clientPhone })
            });

            const client = await response.json();
            setClients(prev => [...prev, client]);
        } catch (error) {
            console.error("Error adding client:", error);
        }
    };

    // Edit a client
    const editClient = async (id, clientName, clientGSTIN, clientAddress, clientEmail, clientPhone) => {
        try {

            const response = await fetch(`${host}/api/clients/updateclient/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                },
                body: JSON.stringify({ clientName, clientGSTIN, clientAddress, clientEmail, clientPhone })
            });

            const updatedClient = await response.json();

            // setClients(clients.map(client => client._id === id ? updatedClient : client));
            setClients(prev => prev.map(client => client._id === id ? updatedClient.client || updatedClient : client));


        } catch (error) {
            console.error("Error editing client:", error);
        }
    }

    // Delete a client
    const deleteClient = async (id) => {
        try {
            await fetch(`${host}/api/clients/deleteclient/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                }
            });
    
            // setClients(clients.filter(client => client._id !== id));
            setClients(prev => prev.filter(client => client._id !== id));


        } catch (error) {
            console.error("Error deleting client:", error);
        }
    };

    return (
        <clientContext.Provider value={{ clients, fetchAllClients, addClient, editClient, deleteClient }}>

            {props.children}

        </clientContext.Provider>
    );

};

export default ClientState;